export default "__VITE_ASSET__fd167a43__"